import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Header from '../PartialViews/section-header';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import BrushIcon from '@material-ui/icons/Brush';
import PieChartIcon from '@material-ui/icons/PieChart';
import SportsMotorsportsIcon from '@material-ui/icons/SportsMotorsports';
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation';
import WidgetsIcon from '@material-ui/icons/Widgets';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
    root: {
        minHeight: "100vh",
        paddingTop: "65px",
        paddingBottom: "65px"
    },
    icon: {
        border: "5px solid #4c8ecb",
        color: "#4c8ecb",
        padding: "20px"
    },
    svg: {
        width: "1.5em",
        height: "1.5em"
    },
    button: {
        borderRadius: "30px",
        padding: "7px 50px",
        color: "#f5deb3",
        border: "2px solid #f5deb3",
        backgroundImage: "linear-gradient(to top, rgba(245, 222, 179, 0.3), rgba(76, 142, 203, 0.6))"
    }
}));

const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector('#scroll-to-top-anchor');

    if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};

export default function Services() {
    const classes = useStyles();

    return (
        <>
            <Header>
                <Typography variant="h2" style={{ color: "wheat" }} className={`${"wow fadeInRight"}`} gutterBottom><b>Services</b></Typography>
                <Box mt={3}>
                    <Button 
                        variant="outlined" 
                        onClick={handleClick}
                        className={`${classes.button} ${"wow"} ${"rubberBand"}`} 
                        style={{animatinoDelay:"0.5s", MozAnimationDelay: "0.5s", WebkitAnimationDelay: "0.5s"}}
                        disableElevation
                        >Learn more</Button>
                </Box>
            </Header>
            <Container id="scroll-to-top-anchor" style={{ backgroundColor: "#fff" }}>
                <Grid container className={classes.root} justify="space-around" spacing={5}>
                    <Grid item xs={12} sm={3}>
                        <Grid container justify="center">
                            <Grid item>
                                <IconButton 
                                    className={`${classes.icon} ${"wow"} ${"bounceInUp"}`}
                                    >
                                    <BrushIcon className={classes.svg} />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" className={"wow bounceInUp"} style={{ color: "#4c8ecb"}}>
                                    <Box my={2} textAlign="center">
                                        Digital Art
                                    </Box>
                                </Typography>
                                <Box textAlign="justify">
                                <Typography className={"wow bounceInUp"}>
                                    This service involves a realistic digital drawing of your choosing using Adobe Photoshop. The drawing can come in the form of a digital copy or a printed copy framed in any size of your choice.
                                </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Grid container justify="center">
                            <Grid item>
                                <IconButton 
                                className={`${classes.icon} ${"wow"} ${"bounceInUp"}`}
                                >
                                    <PieChartIcon className={classes.svg} />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" className={"wow bounceInUp"} style={{ color: "#4c8ecb"}}>
                                    <Box my={2} textAlign="center">
                                        Graphic Design
                                    </Box>
                                </Typography>
                                <Box textAlign="justify">
                                <Typography className={"wow bounceInUp"}>
                                This services involves general branding including logo, stickers, business cards, packaging etc. It also involves design of printable flyers, social media flyers and so on.
                                    
                                </Typography>
                                    </Box>
                                
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Grid container justify="center">
                            <Grid item>
                                <IconButton 
                                    className={`${classes.icon} ${"wow"} ${"bounceInUp"}`}
                                    >
                                    <SportsMotorsportsIcon className={classes.svg} />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" className={"wow bounceInUp"} style={{ color: "#4c8ecb"}}>
                                    <Box my={2} textAlign="center">
                                        Augmented Reality
                                    </Box>
                                </Typography>
                                <Box textAlign="justify">
                                <Typography className={"wow bounceInUp"}>
                                    This services involves the use of AR technology to improve your marketing e.g by creating an interactive business card, or an interactive flyer or an AR visualization of your product or an AR effect for instagram.
                                    </Typography>
                                        
                                    </Box>
                                
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                            <Grid container justify="center">
                                <Grid item>
                                    <IconButton 
                                        className={`${classes.icon} ${"wow"} ${"bounceInUp"}`}
                                        >
                                        <ThreeDRotationIcon className={classes.svg} />
                                    </IconButton>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h5" className={"wow bounceInUp"} style={{ color: "#4c8ecb"}}>
                                        <Box my={2} textAlign="center">
                                            3D Design
                                    </Box>
                                    </Typography>
                                    <Box textAlign="justify">
                                    <Typography className={"wow bounceInUp"}>
                                    This services involves the creation of 3D models of your product for use in Augmented Reality Marketing
                                        </Typography>
                                        
                                        </Box>
                                    
                                </Grid>
                            </Grid>
                        </Grid>
                    <Grid item xs={12} sm={4}>
                        <Grid container justify="center">
                            <Grid item>
                                <IconButton 
                                    className={`${classes.icon} ${"wow"} ${"bounceInUp"}`}
                                    >
                                    <WidgetsIcon className={classes.svg} />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography variant="h5" className={"wow bounceInUp"} style={{ color: "#4c8ecb"}}>
                                    <Box my={2} textAlign="center">
                                        Web Design &amp; Development
                                    </Box>
                                </Typography>
                                <Box textAlign="justify">
                                <Typography className={"wow bounceInUp"}>
                                This services involves the design and development of web applications using one or some of the skill outlined in About section. 
                                    </Typography>
                                    
                                    </Box>
                                
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}